var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4036 19.15C17.4036 17.1175 14.7407 15.47 11.4559 15.47C8.17105 15.47 5.50817 17.1175 5.50817 19.15M22.1618 15.4705C22.1618 13.9615 20.6937 12.6645 18.5931 12.0967M0.75 15.4705C0.75 13.9615 2.21801 12.6645 4.31863 12.0967M18.5931 7.17295C19.3232 6.49913 19.7827 5.51989 19.7827 4.43C19.7827 2.3976 18.185 0.75 16.214 0.75C15.3 0.75 14.4664 1.10432 13.835 1.68704M4.31863 7.17295C3.58855 6.49913 3.12908 5.51989 3.12908 4.43C3.12908 2.3976 4.72682 0.75 6.69771 0.75C7.6117 0.75 8.44543 1.10432 9.0768 1.68704M11.4559 11.79C9.48493 11.79 7.88725 10.1425 7.88725 8.11C7.88725 6.0776 9.48493 4.43 11.4559 4.43C13.4268 4.43 15.0245 6.0776 15.0245 8.11C15.0245 10.1425 13.4268 11.79 11.4559 11.79Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.856399808ac70b9bba7739207a113985.svg";
export { ForwardRef as ReactComponent };